import { defineStore } from 'pinia'
import { ref } from 'vue'
import { updateAbilities } from '../mixins/userMixin'
import { toast } from '../mixins/dialogMixin'

export const useProjectRules = defineStore('projectRules', () => {
  const ruleVersions = ref([])
  const hasOldVersions = ref(false)
  const categories = ref([])
  const currentProjectId = ref(null)
  const currentPhaseId = ref(null)
  const showsIrrelevant = ref(false)

  const load = async (projectId, phaseId, showIrrelevant = false) => {
    currentProjectId.value = projectId
    currentPhaseId.value = phaseId
    showsIrrelevant.value = showIrrelevant

    try {
      const response = await axios.get(route('api.project.rule.index', {
        project_id: currentProjectId.value,
        phase_id: currentPhaseId.value,
        show_irrelevant: showsIrrelevant.value,
      }))
      updateAbilities(response.data.permissions)
      ruleVersions.value = response.data.ruleVersions
      hasOldVersions.value = response.data.hasOldVersions
      categories.value = response.data.categories
    } catch (e) {
      console.error(e)
      toast('error', 'Richtlijnen kunnen niet geladen worden')
    }
  }

  const reload = async () => {
    if (!currentProjectId.value || !currentPhaseId.value) {
      throw Error('No project loaded')
    }
    load(currentProjectId.value, currentPhaseId.value, showsIrrelevant.value)
  }

  const toggleIrrelevant = () => {
    showsIrrelevant.value = !showsIrrelevant.value
    reload()
  }

  return {
    load,
    reload,
    ruleVersions,
    hasOldVersions,
    categories,
    showsIrrelevant,
    toggleIrrelevant,
  }
})
